import { render } from "./Section.vue?vue&type=template&id=54d3ac8e"
import script from "./Section.vue?vue&type=script&lang=js"
export * from "./Section.vue?vue&type=script&lang=js"
script.render = render

export default script